export const MCAAD_WALL_FALLBACK_CARDS = [
  {
    id: "mcaad-fallback-family-conversation",
    question:
      "What's a conversation you're glad we had as a family, even though it might have been difficult?",
    translation:
      "비록 어려웠을지라도, 가족으로서 나눠서 다행이라고 생각하는 대화는 무엇인가요?",
    language: "Korean",
    theme: "Family",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-listening",
    question:
      "Is there someone in your life who was good at listening to you? What did they do that made you feel heard?",
    translation:
      "在您的生活中，有没有人善于倾听您心声？他们做了什么让您感觉被倾听了?",
    language: "Simplified Chinese",
    theme: "Listening",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-childhood-memory",
    question: "What's a childhood memory that still brings you joy?",
    translation: "¿Cuál es un recuerdo de su infancia que todavía le trae alegría?",
    language: "Spanish",
    theme: "Memory",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-family-challenge",
    question: "When have you seen our family come together during challenging times?",
    translation: "어려운 시기에 우리 가족이 함께 뭉쳤던 때는 언제인가요?",
    language: "Korean",
    theme: "Care",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-before-help",
    question: "What should I know before you need me?",
    translation: "도움이 필요해지기 전에 제가 알아야 할 것은 무엇인가요?",
    language: "Korean",
    theme: "Caregiving",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-legacy",
    question: "What legacy are we building together?",
    translation: "우리가 함께 만들어가고 있는 유산은 무엇일까요?",
    language: "Korean",
    theme: "Legacy",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-childhood-story",
    question: "What story from your childhood still guides you?",
    translation: "어린 시절의 어떤 이야기가 지금도 당신을 이끌어주나요?",
    language: "Korean",
    theme: "Story",
    source: "fallback",
  },
  {
    id: "mcaad-fallback-cared-for",
    question: "When do you feel most cared for by our family?",
    translation: "우리 가족에게서 언제 가장 보살핌을 받는다고 느끼나요?",
    language: "Korean",
    theme: "Care",
    source: "fallback",
  },
];

export function buildWallDisplayCards({
  liveCards = [],
  fallbackCards = MCAAD_WALL_FALLBACK_CARDS,
  maxCards,
}) {
  const liveCardsToDisplay = Number.isInteger(maxCards)
    ? liveCards.slice(0, maxCards)
    : liveCards;
  const fallbackSlots = Number.isInteger(maxCards)
    ? Math.max(maxCards - liveCardsToDisplay.length, 0)
    : 0;

  return [
    ...liveCardsToDisplay,
    ...fallbackCards.slice(0, fallbackSlots),
  ];
}
